import qs from 'qs'
import oikosApi from '../../../services/oikos'

export const TP_DOCUMENTO_NF = 27
export const TP_DOCUMENTO_COBRANCA = 29

const insertDocumento = async ({ tpDocumentoId, documentoDesc }) => {
  const res = await oikosApi.post('/', {
    action: 'insert',
    table: 'documento',
    data: {
      tpDocumento_id: tpDocumentoId,
      documento_desc: documentoDesc,
      privacidade_id: 2,
    },
  })
  return res?.data?.[0] || null
}

export const insertDocumentoVinc = async ({ documentoId, tabRef, tabId }) => {
  const id = Number(documentoId) || 0
  const tabIdNum = Number(tabId) || 0
  if (!id || !tabRef || !tabIdNum) return null
  const res = await oikosApi.post('/', {
    action: 'insert',
    table: 'documentoVinc',
    data: {
      documento_id: id,
      documentoVinc_tabRef: tabRef,
      documentoVinc_tabId: tabIdNum,
    },
  })
  return res?.data?.[0] || null
}

const parseArquivoFromUploadRes = (uploadRes) => {
  if (Array.isArray(uploadRes?.data) && uploadRes.data[0]?.arquivo_caminho) {
    return uploadRes.data[0]
  }
  if (uploadRes?.data?.arquivo_caminho) {
    return uploadRes.data
  }
  const resStr = typeof uploadRes?.data === 'string'
    ? uploadRes.data
    : JSON.stringify(uploadRes?.data ?? '')
  const match = resStr.match(/\[\{"arquivo_id".*?\}\]/)
  if (!match) return null
  try {
    const parsed = JSON.parse(match[0])
    return parsed?.[0] || null
  } catch (error) {
    return null
  }
}

const fetchArquivoDoDocumento = async (documentoId) => {
  const id = Number(documentoId) || 0
  if (!id) return null
  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'arquivo',
    data: {
      arquivo_tabRef: 'documento',
      arquivo_tabId: id,
      arquivo_ativo: 1,
    },
    order: 'arquivo_id DESC',
    limit: 1,
  })}`)
  return res?.data?.[0] || null
}

const uploadArquivoDocumento = async (file, documento) => {
  const documentoId = Number(documento?.documento_id) || 0
  if (!file || !documentoId) return null

  const formData = new FormData()
  const filePayload = file.data instanceof Blob
    ? file.data
    : new Blob([file.data], { type: file.data?.type || 'application/octet-stream' })
  const fileName = file.data?.name || file.data?.path || 'arquivo'
  formData.append('file', filePayload, fileName)
  formData.append('table', 'arquivo')
  formData.append('action', 'upload_file')
  formData.append('arquivo_tabRef', 'documento')
  formData.append('arquivo_tabId', documentoId)
  formData.append('arquivo_privacidade', documento.privacidade_id || 2)
  formData.append('arquivo_desc', file.data?.path || fileName)

  const fileUploadRes = await oikosApi.post('/', formData)
  return parseArquivoFromUploadRes(fileUploadRes) || await fetchArquivoDoDocumento(documentoId)
}

const cloneArquivoParaDocumento = async ({ arquivoCaminho, arquivoDesc, documentoId, privacidadeId }) => {
  if (!arquivoCaminho || !documentoId) return null
  const res = await oikosApi.post('/', {
    action: 'insert',
    table: 'arquivo',
    data: {
      arquivo_caminho: arquivoCaminho,
      arquivo_tabRef: 'documento',
      arquivo_tabId: documentoId,
      arquivo_desc: arquivoDesc || undefined,
      arquivo_privacidade: privacidadeId || 2,
    },
  })
  return res?.data?.[0] || null
}

/** Upload uma vez (NF). Cobraça ganha outro arquivo com o mesmo caminho. */
export const createNfECobrancaComArquivoUnico = async (file, { descNf, descCobranca }) => {
  const documentoNf = await insertDocumento({
    tpDocumentoId: TP_DOCUMENTO_NF,
    documentoDesc: descNf,
  })
  const documentoCobranca = await insertDocumento({
    tpDocumentoId: TP_DOCUMENTO_COBRANCA,
    documentoDesc: descCobranca,
  })

  const nfId = Number(documentoNf?.documento_id) || 0
  const cobrancaId = Number(documentoCobranca?.documento_id) || 0
  if (!nfId || !cobrancaId) {
    throw new Error('Falha ao criar documentos de NF e cobrança.')
  }

  const arquivoNf = await uploadArquivoDocumento(file, documentoNf)
    || await fetchArquivoDoDocumento(nfId)
  const arquivoCaminho = arquivoNf?.arquivo_caminho
  if (!arquivoCaminho) {
    throw new Error('Upload da NF não retornou o caminho do arquivo.')
  }

  await cloneArquivoParaDocumento({
    arquivoCaminho,
    arquivoDesc: arquivoNf?.arquivo_desc || file?.data?.path,
    documentoId: cobrancaId,
    privacidadeId: documentoCobranca?.privacidade_id || 2,
  })
  const arquivoCobranca = await fetchArquivoDoDocumento(cobrancaId)
  if (!arquivoCobranca?.arquivo_caminho) {
    throw new Error('Falha ao clonar o arquivo da NF para o documento de cobrança.')
  }

  return { nfId, cobrancaId }
}

export const fetchDocumentoNfDoEvento = async (contrFornEventoId) => {
  const eventoId = Number(contrFornEventoId) || 0
  if (!eventoId) return null

  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documentoVinc_tabRef: 'contrFornEvento',
      documentoVinc_tabId: eventoId,
    },
    fields: {
      documento_id: 'documento_id',
      documentoVinc_id: 'documentoVinc_id',
      '(SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'tpDocumento_id',
    },
  })}`)

  return (res?.data || []).find((row) => Number(row.tpDocumento_id) === TP_DOCUMENTO_NF) || null
}

export const vincularDocumentoAoBdro = async (documentoId, bdroId) => (
  insertDocumentoVinc({
    documentoId,
    tabRef: 'bdro',
    tabId: bdroId,
  })
)
